import { ApplicationError, useBackdropSpinner, useBackdropSpinnerContext } from '@ps-smart-cp/ppfw-client';
import { useState } from 'react';

/**
 * shell内で、ガイドタブを使用しないリクエスト用のhook。
 * error処理が含まれている。
 */

function useTryShell() {
  const { executeRequest } = useBackdropSpinner();
  const { isShowSpinner } = useBackdropSpinnerContext();
  const [error, setError] = useState<string | null>(null);

  const tryRequest = async (request: () => Promise<void>, handleError?: () => void) => {
    try {
      setError(null);
      await executeRequest(request);
    } catch (e) {
      if (handleError) {
        handleError();
      } else {
        if (e instanceof ApplicationError) {
          setError(e.message);
        }
      }
    } finally {
      isShowSpinner(false);
    }
  };

  return {
    error,
    setError,
    tryRequest,
  };
}

export { useTryShell };
